module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a3e689235188ba10c5cfd75730cb88a7.svg";